module.exports = __webpack_public_path__ + "media/secondSection/cyan-circle-75dc20ac.png";